class ProductItem extends HTMLElement {
  constructor() {
    super();

    this.popup = document.querySelector('#quickview-modal')
    this.popupContent = document.querySelector('#quickview-modal [data-modal-content]')
    this.quickviewButton = this.querySelector('[data-quickview-button]')

    this.handle = this.dataset.handle
    this.id = this.dataset.id
  }

  connectedCallback() {
    this.getQuickViewContents();
    this.quickviewButton.addEventListener('click', e => this.handleQuickViewPopup(e))
  }

  async getQuickViewContents() {
    const getSectionHtml = (html, selector) => {
      return new DOMParser()
        .parseFromString(html, 'text/html')
        .querySelector(selector).innerHTML;
    }

    const url = `${window.Shopify.routes.root}products/${this.handle}?view=quickview`
    const productContent = await fetch(url)
    .then((response) => {
      if (response.ok) {
        return response.text();
      } else {
        return false;
        // throw new Error('Something went wrong');
      }
    })
    .catch((error) => {
      console.log(error)
    });

    if (productContent != '') {
      const script = document.createElement('script');
      script.classList.add(`quickview-modal-content-${this.id}`);
      script.setAttribute('type', 'text/template');
      script.innerHTML = getSectionHtml(productContent, '[data-quickview-content-wrap]');

      const quickviewMarkupWrapper = document.querySelector('[data-quickview-content-markups]');
      if (quickviewMarkupWrapper) {
        quickviewMarkupWrapper.append(script);
      } else {
        document.body.append(script);
      }
    }
  }

  // Quick View Popup Events
  handleQuickViewPopup(e) {
    e.preventDefault();
    const markupElement = document.querySelector(`.quickview-modal-content-${this.id}`);
    if (markupElement) {
      if (this.popupContent) {
        this.popupContent.innerHTML = markupElement.innerHTML;
        this.initFormSelectors();
        this.bindFormEvents();
        if (typeof yotpo !== 'undefined') {
          yotpo.refreshWidgets();
        }
        if (typeof MicroModal !== 'undefined') {
          MicroModal.show('quickview-modal');
        }
      }
    }
  }

  initFormSelectors() {
    this.selectors = {
      price: [...this.popupContent.querySelectorAll('[data-js-item-price]')],
      priceCompare: [...this.popupContent.querySelectorAll('[data-js-item-price-compare]')],
      selectedOption: this.popupContent.querySelector('.options-select-inner .options-variant-value'),
      optionsSelect: [...this.popupContent.querySelectorAll('.options-select')],
      frequencyOptions: [...this.popupContent.querySelectorAll('.options-variant-option--frequency')],
      variantOptions: [...this.popupContent.querySelectorAll('.options-variant-option--variant')],
      sellingPlanId: this.popupContent.querySelector('[name="selling_plan"]'),
      idElement: this.popupContent.querySelector('[name="id"]'),
      submitButton: this.popupContent.querySelector('[name="add"]'),
      discountBadge: this.popupContent.querySelector('[data-js-item-discount-badge]')
    }
  }

  bindFormEvents() {
    this.selectors.optionsSelect.forEach((option) => {
      option.addEventListener('click', (e) => {
        option.classList.toggle('open');
      })
    })

    this.selectors.frequencyOptions.forEach((option) => {
      option.addEventListener('change', (e) => {
        this.handleFrequencyChange(e);
        this.updateContent(e);
      })
    })

    this.selectors.variantOptions.forEach((option) => {
      option.addEventListener('change', (e) => {
        if (this.selectors.sellingPlanId) {
          this.selectors.sellingPlanId.disabled = true;
        }
        this.updateContent(e);
      })
    })

    this.selectors.submitButton.addEventListener('click', (e) => this.handleSubmit(e));
  }

  // Quick Buy Form Events
  handleFrequencyChange(e) {
    if (e.target.classList.contains('one-time')) {
      if (this.selectors.sellingPlanId) {
        this.selectors.sellingPlanId.disabled = true;
      }
    } else {
      if (this.selectors.sellingPlanId) {
        this.selectors.sellingPlanId.disabled = false;
      }
    }
  }

  updateContent(e) {
    const { variantPriceCompare, variantPrice, variantId, discountAmount } = e.target.dataset

    // Update Selected Option
    if (this.selectors.selectedOption) {
      const label = e.target.nextElementSibling;
      if (label) {
        this.selectors.selectedOption.innerHTML = label.innerHTML;
      }
    }

    // Update Price
    this.selectors.price.forEach((priceElement) => {
      priceElement.textContent = variantPrice;
    })

    this.selectors.priceCompare.forEach((priceElement) => {
      priceElement.textContent = variantPriceCompare;
    })

    // Update IDs
    if (this.selectors.submitButton) {
      this.selectors.submitButton.dataset.variantId = variantId
    }

    if (this.selectors.idElement) {
      this.selectors.idElement.value = variantId
    }

    // Update Selling Plan ID
    if (this.selectors.sellingPlanId) {
      this.selectors.sellingPlanId.value = e.target.value
    }

    // Hide Select Option
    const selectOption = e.target.closest('.options-select');
    selectOption.classList.remove('open');

    // Update Discount Badge
    if (this.selectors.discountBadge && parseFloat(discountAmount) != 0) {
      this.selectors.discountBadge.textContent = `Save ${parseFloat(discountAmount)}%`;
      this.selectors.discountBadge.classList.remove('hide');
    } else {
      this.selectors.discountBadge.classList.add('hide');
    }
  }

  // Add item to cart
  handleSubmit(e) {
    e.preventDefault();

    const data = {
      id: this.selectors.submitButton.dataset.variantId,
      quantity: 1
    }
    if (this.selectors.sellingPlanId && this.selectors.sellingPlanId.value) {
      data.selling_plan = this.selectors.sellingPlanId.value
    }
    if (Rebuy && Rebuy.Cart) {
      Rebuy.Cart.addItem(data)
    }
  }
}

if (!customElements.get('product-item')) {
  window.customElements.define("product-item", ProductItem);
}
